import * as utilMonitoring from '@/api/monitoring'
import store from '@/store'
import { getApplicationType } from '@/utils/auth'

const state = {
  switchAccount: 0,
  multiAccountSubdomain: '',
  multiAccountToken: '',
  penjualanBlnIni: 0

}

const mutations = {
  SET_PENJUALAN_BULAN_INI: (state, value) => {
    state.penjualanBlnIni = value
  },
  SET_MULTI_ACCOUNT_SUBDOMAIN: (state, value) => {
    state.multiAccountSubdomain = value
  },
  SET_MULTI_ACCOUNT_TOKEN: (state, value) => {
    state.multiAccountToken = value
  },
  SET_SWITCH_ACCOUNT: (state, value) => {
    state.switchAccount = value
  }
}

const actions = {
     async cabangList({commit}) {

      var prefixUrl=(getApplicationType()=="OFFLINE")?"inofarma_":"inofarmapos_"
      return new Promise((resolve, reject) => {
          utilMonitoring.cabangList().then(response => {
          const { data } =  response
          var cabangArr=data.cabang
          console.log("cabangArr",cabangArr)
          if (cabangArr.length>0){
            var dataArr = {}
            cabangArr.forEach(rowArr => {
              dataArr = {"subdomain":prefixUrl+rowArr.online_prefix,"subdomain_name":rowArr.online_prefix,"token":"","username":"","password":""}
              store.dispatch("user/pushMultiLoginAccount",dataArr)
            })
          }
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },  
    async grandTotalPenjualanBulanIni({
      commit
    }) {
      return new Promise((resolve, reject) => {
        utilMonitoring.grandTotalPenjualanBulanIni().then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    async totalNoStockNoExpired({
      commit
    }) {
      return new Promise((resolve, reject) => {
        utilMonitoring.totalNoStockNoExpired().then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    async totalDefecta({
      commit
    }) {
      return new Promise((resolve, reject) => {
        utilMonitoring.totalDefecta().then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
  // setMultiAccountData
    setMultiAccountData({ commit },  dataArr) {
        return new Promise(resolve => {
        const { subdomain, token } = dataArr
        commit('SET_MULTI_ACCOUNT_SUBDOMAIN', subdomain)
        commit('SET_MULTI_ACCOUNT_TOKEN', token)
        resolve()
        })
    },
    async setSwitchAccount({ commit },  isSwitch) {
      commit('SET_SWITCH_ACCOUNT', isSwitch)
    },
    updatePenjualanBlnIni({ commit },  numValue) {
      commit('SET_PENJUALAN_BULAN_INI', numValue)
    },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/monitoring.js